import { rundeKaufmaennisch, rundeKaufmaennisch2Digits } from "./calc/rundeKaufmaennisch"
import { PositionMetadaten } from "./positionMetadaten"
import { PositionZeitraum } from "./positionZeitraum"

export class Position {
    positionZeitraum: PositionZeitraum[] = [new PositionZeitraum()]
    positionMetadaten: PositionMetadaten[] = []
    unterPositionen: Position[] = []
    // BT-126
    positionsnummer = ""
    // BT-127
    positionstext = ""
    // BT-128
    positionskennung = ""
    // BT-128-1
    positionskennungCode = ""
    // BT-129
    menge = 0
    // BT-130
    einheit = "C62" // default > Stueck
    // BT-132
    bestellreferenz = ""
    // BT-133
    kontierungshinweis = ""
    // BT-152
    umsatzsteuer = 0
    // BT-151
    umsatzsteuerCode = "S"
    // BT-153
    artikelbezeichnung = ""
    // BT-154
    artikelbeschreibung = ""
    // BT-155
    artikelnummerVerkaeufer = ""
    // BT-156
    artikelnummerKaeufer = ""
    // BT-157
    artikelnummer = ""
    // BT-157-1
    // unbekannte beschreibung/ benutzerdefiniert
    artikelnummerCode = "0197"
    // BT-158
    artikelklassifizierung = ""
    // BT-158-1 - mutualy defined
    artikelklassifizierungSchema = "ZZZ"
    // BT-158-2
    artikelklassifizierungSchemaVersion = ""
    // BT-159
    artikelherkunft = ""
    // BT-146
    einzelpreisNettoMitRabatt = 0
    // BT-147
    rabattGesamt = 0
    // BT-148
    einzelpreisNettoOhneRabatt = 0
    // BT-150
    preisbasisEinheit = "C62" // default > Stueck
    // BT-149
    private _preisbasisMenge = 1

    // BT-149
    get preisbasisMenge(): number {
        return this._preisbasisMenge
    }

    // BT-149
    set preisbasisMenge(basis) {
        if (basis > 0) this._preisbasisMenge = basis
    }

    // BT-131
    get gesamtpreisNetto(): number {
        return this.hatUnterpositionen() ? this.summiereNettoAusUnterpositionen() : this.berechneAusMengeUndPreis()
    }

    // BT-131
    set gesamtpreisNetto(_: number) {
        // ignoriert, weil immer berechnet
    }

    get notEmpty(): boolean {
        return (
            this.positionsnummer.trim().length > 0 ||
            this.menge !== 0 ||
            this.kontierungshinweis.trim().length > 0 ||
            this.artikelbezeichnung.trim().length > 0 ||
            this.einzelpreisNettoMitRabatt !== 0
        )
    }

    hatUnterpositionen = () => this.unterPositionen.length > 0

    toJSON() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { _preisbasisMenge, ...rest } = this
        return {
            ...rest,
            gesamtpreisNetto: rundeKaufmaennisch2Digits(Number(this.gesamtpreisNetto)),
            /** may have too many digits, this is corrected in the back end */
            preisbasisMenge: Number(this.preisbasisMenge)?.toFixed(10), // BT-149
            einzelpreisNettoOhneRabatt: Number(this.einzelpreisNettoOhneRabatt)?.toFixed(2),
            einzelpreisNettoMitRabatt: Number(this.einzelpreisNettoMitRabatt)?.toFixed(2),
            rabattGesamt: Number(this.rabattGesamt)?.toFixed(2),
            umsatzsteuer: rundeKaufmaennisch2Digits(Number(this.umsatzsteuer)),
            /** may have too many digits, this is corrected in the back end */
            menge: Number(this.menge)?.toFixed(10), // BT-129
        }
    }

    private summiereNettoAusUnterpositionen() {
        return this.unterPositionen.reduce((s, p) => s + p.gesamtpreisNetto, 0)
    }

    private berechneAusMengeUndPreis(): number {
        return rundeKaufmaennisch((this.menge * this.einzelpreisNettoMitRabatt * 100) / this.preisbasisMenge) / 100
    }
}
